<!-- 房企选择 -->
<template>
    <el-popover
        placement="bottom-end"
        transition="el-zoom-in-top"
        trigger="click"
        v-model="visible"
        popper-class="tab-search-popper">
        <div class="popperMain">
            <div class="mainHead commonSet">
                <ul class="headTab">
                    <li
                        :class="['tabItem',{'active':activeTabIndex == index}]"
                        v-for="(tab,index) in list"
                        :key="index"
                        @click="activeTabIndex = index">
                        {{tab.tabName}}
                    </li>
                </ul>
                <el-input
                    v-if="activeTabIndex == 1"
                    class="innerSearchIpt"
                    placeholder="搜索房企"
                    prefix-icon="el-icon-search"
                    clearable
                    v-model="searchKey">
                </el-input>
            </div>
            <div class="popperCon">
                <div class="conListBox diyScrollBox">
                    <div class="zfyx-checkbox-group" v-if="activeList.isMultiple">
                        <div class="listHead commonSet">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部房企</el-checkbox>
                        </div>
                        <el-checkbox-group
                            class="zfyx-checkbox-sameWidth commonSet"
                            v-model="checkedVal"
                            @change="handleCheckedChange">
                            <el-checkbox
                                v-show="item.label.indexOf(searchKey) != -1"
                                v-for="(item,index) in activeList.data"
                                :label="item.value" :key="index">
                                {{item.label}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="zfyx-radio-box commonSet" v-else>
                        <el-radio 
                            v-model="checkedRadioVal"
                            v-for="(item,index) in activeList.data"
                            :label="item.label"
                            :key="index"
                            @change="radioCheckedChange">
                            {{item.label}}
                        </el-radio>
                    </div>
                </div>
                <div class="conResBox commonSet diyScrollBox">
                    <div class="resLabel">已选房企：</div>
                    <ul class="resItemBox">
                        <li class="resItem" v-for="(item,index) in defaultCheckObj.data" :key="index">
                            {{item}}<i class="el-icon-error" @click="delItem(item)"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="popperfooter">
                <div class="submitBtn" @click="submitCheck">提交</div>
                <div class="delBtn" @click="clearAll"><i class="el-icon-delete"></i>清空</div>
            </div>
        </div>
        <!-- 显示框 -->
        <slot name="selectTitle" slot="reference">
            <div class="cityValue-ipt-wrap formValBaseWidth">
                <el-input
                    placeholder="不限"
                    class="citySearch cityValue-ipt-areaSelect"
                    readonly
                    :value="firstShowValue">
                    <i slot="suffix" :class="['el-icon-caret-bottom',{'icon_up_amt':visible,'icon_down_amt':!visible}]"></i>
                    <!-- <i
                        v-if="firstShowValue"
                        slot="suffix"
                        :class="['el-icon-caret-bottom',{'icon_up_amt':visible,'icon_down_amt':!visible, 'clearBtn':firstShowValue}]"
                        @click.stop="clearAllEmit">
                    </i>
                    <i
                        v-else
                        slot="suffix"
                        :class="['el-icon-caret-bottom','cursor_pointer',{'icon_up_amt':visible,'icon_down_amt':!visible}]"
                        >
                    </i> -->
                </el-input>
                <div class="cityValue-ipt-areaSelect-tag" v-if="firstShowValue">
                    <div class="tag noClose">{{firstShowValue}}</div>
                    <div class="tag num" v-if="allCheckNum > 1">+{{allCheckNum - 1}}</div>
                </div>
            </div>
        </slot>
    </el-popover>
</template>

<script>
import ajaxService from '@/server/api.js'
export default {
    data() {
        return {
            visible: false,// 控制下拉显示/隐藏
            activeTabIndex:1,//当前所在tab索引
            searchKey:'',
            checkAll:false,
            checkedVal:[],//多选结果
            checkedRadioVal:'',//单选结果
            defaultCheckObj:{},//已选对象
        }
    },
    computed:{
        list(){
            return [
                {
                    tabName:'TOP房企',
                    data:[
                        { value: '30', label: 'TOP30',},
                        { value: '50', label: 'TOP50',},
                        { value: '100', label: 'TOP100',},
                    ],
                    isMultiple:false,//是否多选
                },
                {
                    tabName:'全部房企',
                    data:this.companyList,
                    isMultiple:true,
                },
            ]
        },
        activeList(){
            let temp = this.list[this.activeTabIndex]
            return temp
        },
        firstShowValue(){
            let val = ''
            if(this.companyData.data){
                val = this.companyData.data[0]
                if(!this.companyData.isMultiple){
                    for(let e of this.list[0].data){
                        if(e.value == val){
                            val = e.label
                            break
                        }
                    }
                }
            }
            return val
        },
        allCheckNum(){
            return this.companyData.data ? this.companyData.data.length : 0
        },
        isIndeterminate(){
            if(this.checkAll){
                return false
            }
            if(!this.checkedVal.length){
                return false
            }
            return true
        }
    },
    props:{
        companyList:{
            type:Array,
            default(){
                return [];
            }
        },
        companyData:{
            type:Object,
            default(){
                return {};
            }
        },
    },
    watch:{
        companyData:{
            handler(val){
                this.defaultInit()
            },
            deep:true
        },
        visible(val){
            if(val){
                this.defaultInit()
            }
        }
    },
    created() {},
    methods: {
        defaultInit(){
            this.clearAll()
            if(Object.keys(this.companyData).length){
                this.defaultCheckObj = JSON.parse(JSON.stringify(this.companyData))
                if(!this.defaultCheckObj.isMultiple){
                    this.defaultCheckObj.data = this.defaultCheckObj.data.map(item=>{
                        let val = item
                        for(let e of this.list[0].data){
                            if(e.value == item){
                                val = e.label
                                break
                            }
                        }
                        return val
                    })
                    this.checkedRadioVal = this.defaultCheckObj.data[0]
                    this.activeTabIndex = 0
                }else{
                    if(this.defaultCheckObj.data.length == 1 && this.defaultCheckObj.data[0] == '全部房企'){
                        this.checkedVal = this.list[1].data.map(item=>item.value)
                        this.checkAll = true
                    }else{
                        this.checkedVal = this.defaultCheckObj.data
                    }
                    this.activeTabIndex = 1
                }
            }else{
                this.activeTabIndex = 1
            }
        },
        // 多选全选
        handleCheckAllChange(val){
            this.checkedVal = val ? this.activeList.data.map(item=>item.value) : []

            this.valSet(true)
        },
        // 多选
        handleCheckedChange(val){
            this.checkAll = val.length == this.activeList.data.length

            this.valSet(true)
        },
        // 单选
        radioCheckedChange(val){
            this.valSet(false)
        },
        // 设置已选的显示
        // isMultiple:是否是多选
        valSet(isMultiple){
            let _data
            if(isMultiple){
                if(this.checkedVal.length == this.activeList.data.length){
                    _data = ['全部房企']
                }else{
                    _data = this.checkedVal
                }
                this.checkedRadioVal = ''
            }else{
                _data = [this.checkedRadioVal]
                this.checkedVal = []
            }
            this.defaultCheckObj = {
                isMultiple: isMultiple,
                data: _data
            }
        },
        // 清空
        clearAll(){
            this.checkedRadioVal = ''
            this.checkedVal = []
            this.defaultCheckObj = {}
        },
        // 清除单个选项
        delItem(item){
            if(this.defaultCheckObj.isMultiple){
                if(item == '全部房企'){
                    this.handleCheckAllChange(false)
                    this.checkAll = false
                }else{
                    let index = this.checkedVal.findIndex(e=>e==item)
                    this.checkedVal.splice(index,1)
                }
            }else{
                this.checkedRadioVal = ''
                this.defaultCheckObj = {}
            }
        },

        submitCheck(){
            console.log(this.defaultCheckObj)
            if(this.defaultCheckObj.data){
                if(!this.defaultCheckObj.isMultiple){
                    this.defaultCheckObj.data = this.defaultCheckObj.data.map(item=>{
                        let val = item
                        for(let e of this.list[0].data){
                            if(e.label == item){
                                val = e.value
                                break
                            }
                        }
                        return val
                    })
                }
            }
            this.visible = false
            this.$emit('submitCheck',this.defaultCheckObj);
        },
        clearAllEmit(){
            this.clearAll()
            this.submitCheck()
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
